import { Injectable } from '@angular/core';
import { ParseAPIService, DbObjectsStore } from '../abstract/ParseAPIService';
import { Folder } from '../model/folder.model';
import 'parse';
import { RoiService } from './roi.service';
import { environment } from '../../environments/environment';
import { TchekImageUrl } from '../model/image';
const parse: typeof Parse = require('parse');

@Injectable()
export class FolderService implements ParseAPIService<Folder> {
    store: DbObjectsStore<Folder>;

    constructor() {
        this.store = {};
    }


    public async getAll(limit?: number): Promise<Folder[]> {
        const query = this.baseQuery();
        if (typeof limit === 'number')
            query.limit(limit);
        try {
            const foundObjects = await query.find();
            foundObjects.forEach(o => this.store[o.id] = new Folder(o));
            return Object.values(this.store);
        } catch (e) {
            console.error(e);
            return [];
        }
    }

    public async get(id: string): Promise<Folder> {
        const query = this.baseQuery();
        try {
            this.store[id] = new Folder(await query.get(id));
            return this.store[id];
        } catch (e) {
            console.error(e);
            return undefined;
        }
    }

    public async getByTchek(id: string): Promise<Folder[]> {
        const query = this.baseQuery();
        let tchek = {
            __type: "Pointer",
            className: "Tchek",
            objectId: id
          };
        try {
            const foldersFound = [];
            (await query.equalTo('tchekPtr', tchek).find())
                .forEach(d => {
                    this.store[d.id] = new Folder(d);
                    foldersFound.push(this.store[d.id]);
                });
            return foldersFound;
        } catch (e) {
            console.error(e);
            return undefined;
        }
    }

    public async countByTchek(id: string): Promise<number> {
        const query = this.baseQuery();
        const tchek = new parse.Object('Tchek');
        tchek.id = id;
        try {
            await tchek.fetch();
            return await query.equalTo('tchekPtr', tchek).count();
        } catch (e) {
            console.error(e);
            return undefined;
        }
    }

    public async save(folder: Folder | Folder[]): Promise<Folder | Folder[]> {
        if (Array.isArray(folder)) {
            const array = folder.map<Parse.Object>(f => f.getParseInstance());
            try {
                const savedObjects = await parse.Object.saveAll(array);
                const foldersFound = [];
                savedObjects.forEach(d => {
                    this.store[d.id] = new Folder(d);
                    foldersFound.push(this.store[d.id]);
                });
                return foldersFound;
            } catch (e) {
                console.error(e);
                return [];
            }
        } else {
            try {
                const savedObject = await folder.getParseInstance().save();
                this.store[savedObject.id] = new Folder(savedObject);
                return this.store[savedObject.id];
            } catch (e) {
                console.error(e);
                return undefined;
            }
        }
    }

    public async delete(folder: Folder | Folder[]): Promise<Folder | Folder[]> {
        throw new Error('folderService.delete() is not implemented');
    }

    public async destroy(folder: Folder | Folder[]): Promise<Folder | Folder[]> {
        if (Array.isArray(folder)) {
            const array = folder.map<Parse.Object>(f => f.getParseInstance());
            try {
                const destroyedObjects = await parse.Object.destroyAll(array);
                return destroyedObjects.map<Folder>(o => new Folder(o));
            } catch (e) {
                console.error(e);
                return [];
            }
        } else {
            try {
                const destroyedObject = await folder.getParseInstance().destroy();
                return new Folder(destroyedObject);
            } catch (e) {
                console.error(e);
                return undefined;
            }
        }
    }

    private baseQuery(): Parse.Query {
        return new parse.Query('Folder')
            .include('tchekPtr');
    }

}



// WEBPACK FOOTER //
// ./src/app/service/folder.service.ts